const _ = require('lodash');

const Flow = require('./flow');

const FlowTemplate = require('./flow-template');
/*:: type Action = ['present' | 'call' | 'website'];*/

/*:: type Validation = ['none' | 'location' | 'pin' | 'location+pin'];*/


const getFlowVar = varName => flow => _.get(flow, `vars.${varName}`, null);

const getAction = getFlowVar('redeemedActionType');

const getValidation = flow =>
/*: Validation*/
{
  const byLocation = flow.vars.redeemByLocation;
  const byPin = flow.vars.redeemByPin;
  const byPrompt = flow.vars.redeemByPrompt;
  const byLocationAndPin = flow.vars.redeemByLocationAndPin;
  if (byLocationAndPin) return 'location+pin';
  if (byPin) return 'pin';
  if (byLocation && byPrompt) return 'location+fallback';
  if (byLocation) return 'location';
  return 'none';
};

const getPunchValidation = flow =>
/*: Validation*/
{
  const byLocation = flow.vars.punchByLocation;
  const byPin = flow.vars.punchByPin;
  const byPrompt = flow.vars.punchByPrompt;
  const byLocationAndPin = flow.vars.punchByLocationAndPin;
  if (byLocationAndPin) return 'location+pin';
  if (byPin) return 'pin';
  if (byPrompt) return 'location+fallback';
  if (byLocation) return 'location';
  return 'none';
};

const phoneToken = `\${phone}`;

const isPhoneSet = flow =>
/*: boolean*/
flow.vars.redeemedActionTarget !== phoneToken && flow.vars.redeemedActionType === 'call';

const getPhone = flow => flow.vars.redeemedActionType === 'call' && isPhoneSet(flow) ? flow.vars.redeemedActionTarget : null;

const getUrl = flow => flow.vars.redeemedActionType === 'website' ? flow.vars.redeemedActionTarget : null;

const getLabel = getFlowVar('redeemedTransitionButtonText');
const getPunchLabel = getFlowVar('punchTransitionButtonText');

const getIsLimited = flow => !!(flow.vars.redeemLimitGlobal || flow.vars.redeemLimitPerProfileResetWindowQuantity || flow.vars.redeemLimitPerProfile);

const getGlobalLimit = getFlowVar('redeemLimitGlobal');
const getUserLimitResetGranularity = getFlowVar('redeemLimitPerProfileResetWindowGranularity');

const getUserLimit = flow => {
  const isGranularitySet = !!getUserLimitResetGranularity(flow);
  return isGranularitySet ? getFlowVar('redeemLimitPerProfileResetWindowQuantity')(flow) : getFlowVar('redeemLimitPerProfile')(flow);
};

const LIMITED_VALIDATIONS = ['none', 'pin', 'location', 'location+pin', 'location+fallback'];

const canBeLimited = vars => LIMITED_VALIDATIONS.includes(vars.validation) && vars.isLimited;

const PIN_VALIDATIONS = ['pin'];

const serializeValidations = vars => {
  const byLocationOnly = vars.validation === 'location' && vars.action === 'present';
  const byLocationWithFallback = vars.validation === 'location+fallback';
  const byPin = PIN_VALIDATIONS.includes(vars.validation);
  const byLocationAndPin = vars.validation === 'location+pin';
  const byNoValidation = !byLocationOnly && !byLocationWithFallback && !byPin && !byLocationAndPin;
  return {
    redeemByLocation: byLocationOnly || byLocationWithFallback,
    redeemByPin: byPin,
    redeemByPrompt: byLocationWithFallback,
    redeemByNoValidation: byNoValidation,
    redeemByLocationAndPin: byLocationAndPin
  };
};

const serializePunchValidations = vars => {
  const byLocation = vars.punchValidation === 'location' || vars.punchValidation === 'location+fallback';
  const byPin = vars.punchValidation === 'pin';
  const byPrompt = vars.punchValidation === 'location+fallback';
  const byLocationAndPin = vars.punchValidation === 'location+pin';
  const byNoValidation = !byLocation && !byPin && !byPrompt && !byLocationAndPin;
  return {
    punchByLocation: byLocation,
    punchByPrompt: byPrompt,
    punchByNoValidation: byNoValidation,
    punchByPin: byPin,
    punchByLocationAndPin: byLocationAndPin
  };
};

const serializeAction = vars => {
  const action = vars.action;
  let target;

  if (action === 'call') {
    if (vars.setPhone) {
      target = vars.phone;
    } else {
      target = phoneToken;
    }
  } else if (action === 'website') {
    target = vars.url;
  } else {
    target = null;
  }

  return {
    redeemedActionType: action,
    redeemedActionTarget: target,
    // FIXME: Localization hack to match the one in flow.js
    redeemedTransitionButtonText: {
      default: vars.label
    }
  };
};

const serializeGlobalLimits = vars => {
  const hasLimits = canBeLimited(vars);
  const globalLimit = vars.globalLimit === '' ? null : vars.globalLimit;
  return {
    redeemLimitGlobal: hasLimits ? globalLimit : null,
    redeemLimitGlobalResetWindowQuantity: null,
    redeemLimitGlobalResetWindowGranularity: null
  };
};

const serializeUserLimits = vars => {
  // only set redemption limits if we have location validation
  const isLimited = canBeLimited(vars);
  const redeemLimitPerProfileResetWindowGranularity = isLimited ? vars.userLimitResetGranularity : null;
  let redeemLimitPerProfile;
  let redeemLimitPerProfileResetWindowQuantity;

  if (redeemLimitPerProfileResetWindowGranularity) {
    redeemLimitPerProfileResetWindowQuantity = isLimited ? vars.userLimit : null;
    redeemLimitPerProfile = null;
  } else {
    redeemLimitPerProfile = isLimited ? vars.userLimit : null;
    redeemLimitPerProfileResetWindowQuantity = null;
  }

  return {
    redeemLimitPerProfile,
    redeemLimitPerProfileResetWindowGranularity,
    redeemLimitPerProfileResetWindowQuantity
  };
};

const serializePunchcardVars = vars => ({
  punchExpiresAfter: vars.punchExpiresAfter,
  punchUnfrozenAfter: vars.punchUnfrozenAfter && Math.round(vars.punchUnfrozenAfter * 3600),
  punchTransitionButtonText: vars.punchTransitionButtonText
});

class SimpleFlow {
  /*:: static toFlow(Object): Flow */
  constructor(flow
  /*: Flow*/
  ) {
    this.vars = {
      action: 'present',
      validation: null,
      phone: null,
      setPhone: false,
      url: null,
      label: 'Use Now',
      isLimited: false,
      globalLimit: null,
      userLimit: null,
      userLimitResetGranularity: null,
      punchExpiresAfter: null,
      punchUnfrozenAfter: 12,
      redeemSegmentId: undefined
    };
  }

}

const getFlowVars = simpleFlow =>
/*: Object*/
Object.assign({}, simpleFlow.flow ? simpleFlow.flow.vars : {}, // base flow vars, overridden by subsequent lines
serializeValidations(simpleFlow.vars), serializePunchValidations(simpleFlow.vars), serializeAction(simpleFlow.vars), serializeGlobalLimits(simpleFlow.vars), serializeUserLimits(simpleFlow.vars), serializePunchcardVars(simpleFlow.vars), {
  redeemSegmentId: simpleFlow.vars.redeemSegmentId
});

SimpleFlow.toFlow = simpleFlow => {
  if (!simpleFlow.flow) throw new Error('Cannot serialize simpleFlow with no template');
  const vars = getFlowVars(simpleFlow);
  const newFlowInitVars = Object.assign({}, simpleFlow.flow, {
    vars
  });
  return new Flow(newFlowInitVars);
};

SimpleFlow.duplicate = simpleFlow => {
  const flow = SimpleFlow.toFlow(simpleFlow);
  flow.vars.redeemSegmentId = undefined; // never duplicate segment id

  return SimpleFlow.fromFlow(flow);
};

const getPunches = flow => _.get(flow, 'template.generator.input.punches', null);

const getPunchUnfrozenAfter = flow => {
  const value = getFlowVar('punchUnfrozenAfter')(flow);
  return value && value / 3600;
};

SimpleFlow.fromFlow = (flow
/*: Flow*/
) => {
  const simpleFlow = new SimpleFlow();
  simpleFlow.flow = flow;
  simpleFlow.vars.action = getAction(flow);
  simpleFlow.vars.validation = getValidation(flow);
  simpleFlow.vars.punchValidation = getPunchValidation(flow);
  simpleFlow.vars.phone = getPhone(flow);
  simpleFlow.vars.setPhone = isPhoneSet(flow);
  simpleFlow.vars.url = getUrl(flow);
  simpleFlow.vars.label = getLabel(flow);
  simpleFlow.vars.isLimited = getIsLimited(flow);
  simpleFlow.vars.globalLimit = getGlobalLimit(flow);
  simpleFlow.vars.userLimit = getUserLimit(flow);
  simpleFlow.vars.userLimitResetGranularity = getUserLimitResetGranularity(flow);
  simpleFlow.vars.punchExpiresAfter = getFlowVar('punchExpiresAfter')(flow);
  simpleFlow.vars.punchUnfrozenAfter = getPunchUnfrozenAfter(flow); // Default redeemSegmentId to `undefined` so it can be automatically set by the API if we save without one

  simpleFlow.vars.redeemSegmentId = getFlowVar('redeemSegmentId')(flow) || undefined;
  simpleFlow.vars.punchTransitionButtonText = getPunchLabel(flow);
  simpleFlow.vars.punches = getPunches(flow);
  simpleFlow.type = SimpleFlow.determineType(simpleFlow);
  return simpleFlow;
};

SimpleFlow.determineType = simpleFlow => {
  if (simpleFlow.vars.punches) return 'punchcard';
  if (simpleFlow.vars.isLimited) return 'limited';
  return 'default';
};

SimpleFlow.determineRequiredGenerator = simpleFlow => {
  if (simpleFlow.type === 'punchcard') {
    return {
      template: 'punchcard',
      input: {
        punches: simpleFlow.vars.punches
      }
    };
  }

  return {
    template: 'default',
    input: {}
  };
};

SimpleFlow.determineExistingGenerator = simpleFlow => {
  if (!simpleFlow.flow || !simpleFlow.flow.template) return null;
  return FlowTemplate.determineGenerator(simpleFlow.flow.template);
};

SimpleFlow.setTemplate = (simpleFlow
/*: SimpleFlow*/
, template
/*: FlowTemplate*/
) => {
  /* eslint-disable-next-line no-param-reassign */
  simpleFlow.flow = new Flow({
    template
  });
  return simpleFlow;
};

module.exports = SimpleFlow;